import React, { useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';
import CommonTable from '../../common/components/CommonTable';
import EditDealerChangesTableRow from './EditDealerChangesTableRow';

const headers = [
  {
    label: 'Date',
  },
  {
    label: 'Author',
  },
  {
    label: 'Change',
  },
];

function EditDealerChangesTable({ data, offset, changeOffset }) {
  const [show, setShow] = useState(false);

  return (
    <>
      <Button
        className="rounded-pill btn-light w-100 mb-2"
        type="button"
        onClick={() => setShow((prev) => !prev)}
      >
        Changes {show ? '-' : '+'}
      </Button>
      {show && (
        <Row>
          <Col xs="12">
            <CommonTable
              rowComponent={EditDealerChangesTableRow}
              data={data}
              offset={offset}
              onOffsetChange={changeOffset}
              headers={headers}
              hasRowPointer={false}
            />
          </Col>
        </Row>
      )}
    </>
  );
}

EditDealerChangesTable.propTypes = {
  changeOffset: PropTypes.func.isRequired,
};

export default EditDealerChangesTable;
